<template>
	<section class="footer-modal">
		<div class="footer-container">
			<small v-if="helperText" class="footer-helper">
				<v-icon>info_outline</v-icon>{{ helperText }}
			</small>
			<div class="footer-buttons">
				<v-btn
					class="btn-action cancel-action caption"
					color="pink"
					:disabled="onRunService"
					v-if="!hidden"
					@click="cancelModal"
				>
					Cancelar
					<v-icon class="ml-2" size="18">close</v-icon>
				</v-btn>
				<v-btn
					class="btn-action save-action caption"
					:color="successColor"
					:disabled="isLoading"
					v-if="!hiddenSaveBtn"
					@click="setInfo"
				>
					{{ successText }}
					<v-icon class="ml-2" size="18">check</v-icon>
				</v-btn>
				<slot></slot>
			</div>
		</div>
	</section>
</template>

<script>

function cancelModal() {
	this.$emit('cancel-button-clicked');
}

function setInfo() {
	this.$emit('accept-button-clicked');
}

export default {
	name: 'modal-sidebar-button',
	methods: {
		cancelModal,
		setInfo,
	},
	props: {
		isLoading: {
			default: true,
			type: Boolean,
		},
		hidden: {
			type: Boolean,
			default: false,
		},
		hiddenSaveBtn: {
			type: Boolean,
			default: false,
		},
		helperText: {
			default: '',
			type: String,
		},
		onRunService: {
			default: false,
			type: Boolean,
		},
		successColor: {
			default: 'primary',
			type: String,
		},
		successImg: {
			default: 'icon-apply.svg',
			type: String,
		},
		successText: {
			default: 'Guardar',
			type: String,
		},
	},
};
</script>

<style lang="scss" scoped>
	.footer-modal {
	backdrop-filter: blur(6px);
	background: rgba(255, 255, 255, .96);
	border-top: 1px solid #dde6ed;
	box-shadow: 0 -6px 20px rgba(30, 53, 76, .08);
	height: 64px;
	width: 100%;
	.footer-container {
		align-items: center;
		display: flex;
		gap: 10px;
		height: 100%;
		justify-content: flex-end;
		padding: 0 18px;
		.footer-helper {
			align-items: center;
			color: #8495a5;
			display: flex;
			flex: 1 1 auto;
			font-size: 11px;
			gap: 5px;
			line-height: 1.3;
			min-width: 0;
			.icon { color: #b4bfca; font-size: 15px; }
		}
		.footer-buttons {
			align-items: center;
			display: flex;
			flex: 0 0 auto;
			gap: 8px;
		}
		.btn {
			border-radius: 8px;
			box-shadow: none !important;
			color: white;
			height: 36px !important;
			letter-spacing: .02em;
			margin: 0 !important;
			min-width: 108px;
			width: auto !important;
			&.cancel-action {
				background: #fff !important;
				border: 1px solid #d4dee7;
				color: #53697d !important;
				&:hover:not([disabled]) { background: #f1f5f9 !important; }
			}
			&.save-action {
				background: #1A4338 !important;
				box-shadow: 0 5px 12px rgba(26, 67, 56, .22) !important;

				&:hover,
				&:focus { background: #2E6B59 !important; }
			}
		}
		.cancel {
			background-color: map-get($colors, error);
		}
		.send {
			background-color: map-get($colors, success);
		}
	}
}

@media (max-width: 700px) {
	.footer-modal .footer-container {
		padding: 0 12px;
		.footer-helper { display: none; }
		.btn { min-width: 96px; }
	}
}
</style>



// WEBPACK FOOTER //
// src/components/shared/utils/modal-sidebar-button.vue